import axiosInstance from "@/config/axiosInstance";
import { endpoints } from "@/config/apiEndpoints";

const CURRENT_USER_TTL_MS = 10000;

let cachedUser: any = null;
let cachedAt = 0;
let inflightRequest: Promise<any> | null = null;

const isCacheFresh = () =>
  cachedUser !== null && Date.now() - cachedAt < CURRENT_USER_TTL_MS;

export const getCurrentUser = async (forceRefresh = false) => {
  if (!forceRefresh && isCacheFresh()) {
    return cachedUser;
  }

  if (!forceRefresh && inflightRequest) {
    return inflightRequest;
  }

  inflightRequest = axiosInstance
    .get(endpoints.me)
    .then((response) => {
      cachedUser = response.data;
      cachedAt = Date.now();
      return cachedUser;
    })
    .finally(() => {
      inflightRequest = null;
    });

  return inflightRequest;
};

export const invalidateCurrentUserCache = () => {
  cachedUser = null;
  cachedAt = 0;
  inflightRequest = null;
};

export const getCachedUserSync = () => cachedUser;

export const isAdminUser = (user: any) =>
  !!(user?.is_superuser || user?.is_staff);
